import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";

const ClockContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 15px;
  margin: 0 10px;
  p {
    color: white;
    font-size: calc(7px + 7vmin);
    text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
    padding: 0;
    margin: 10px;
  }
`;

const Clock = () => {
  const [time, setTime] = useState(new Date().toLocaleTimeString());
  const [intervalID, setIntervalID] = useState();

  useEffect(() => {
    function tick() {
      setTime(new Date().toLocaleTimeString());
    }

    setIntervalID(() => {
      setInterval(() => tick(), 1000);
    });

    return () => {
      clearInterval(intervalID);
    };
  }, [intervalID, time]);

  return (
    <ClockContainer>
      <p className="App-clock">{time}</p>
    </ClockContainer>
  );
};

export default Clock;
